import * as preact from "preact";
import PropTypes from "prop-types";

import classname from "../../foundation/utils/classname";
import IconMagnifier from "../Icons/IconMagnifier";

import FilterInput from "../FilterInput";

import styles from "./FilterBar.module.css";

const { h } = preact;

function FilterBar(props) {
    const {
        class: cssClass,
        filterValue,
        onFilter,
        leftContent,
        rightContent,
        searchPlaceholder,
        searchPlaceholderWidth,
        searchDisabled,
        sticky,
        alignLeftCenterItem,
        filterInputClass
    } = props;

    return (
        <div class={classname(styles.filterBar, { [styles.sticky]: sticky }, cssClass)}>
            <div class={classname(styles.bumper, { [styles.left]: alignLeftCenterItem })}>{leftContent}</div>
            <FilterInput
                icon={<IconMagnifier color="var(--gandalf)"/>}
                placeholder={searchPlaceholder}
                placeholderWidth={searchPlaceholderWidth}
                value={filterValue}
                onFilter={onFilter}
                disabled={searchDisabled}
                class={filterInputClass}/>
            <div class={styles.bumper}>{rightContent}</div>
        </div>
    );
}

FilterBar.propTypes = {
    /** Search input's placeholder */
    searchPlaceholder: PropTypes.string,
    /** Search input's placeholder width */
    searchPlaceholderWidth: PropTypes.number.isRequired,
    /** Filter value used while the components/screens are being filtered.  */
    filterValue: PropTypes.string,
    /** Callback to be called when a search term is typed. */
    onFilter: PropTypes.func.isRequired,
    /** Content to be rendered at the left side */
    leftContent: PropTypes.node,
    /** Content to be rendered at the right side */
    rightContent: PropTypes.node,
    /** Whether filtering is disabled or not */
    searchDisabled: PropTypes.bool,
    /** Whether filter bar should stick to top when scrolling or not */
    sticky: PropTypes.bool,
    /** Whether the center item should be next to the left content */
    alignLeftCenterItem: PropTypes.bool
};

FilterBar.defaultProps = {
    filterValue: "",
    searchDisabled: false,
    sticky: false,
    class: "",
    alignLeftCenterItem: false.valueOf,
    filterInputClass: ""
};

export default FilterBar;
